import type { FetchResponse } from '@sydle/ui-api';
import { portalAnonymousCustomAPI, portalCustomAPI } from '.';
import type { Rating } from '../models/nps/Rating';
import type { TicketComment } from '../models/ticket/TicketComment';

export interface RegisterRatingInput {
  comment?: TicketComment;
  rating: Rating;
  ratedType: string;
  pendencyId?: string;
  ratingCode?: string | null;
}

export interface RegisterRatingOutput {
  post?: any;
  rating?: Rating;
}

export async function registerRating(
  input: RegisterRatingInput,
  requestAnonymously?: boolean,
): Promise<FetchResponse<RegisterRatingOutput>> {
  const serviceDeskApi = requestAnonymously ? portalAnonymousCustomAPI : portalCustomAPI;
  return await serviceDeskApi.fetch<RegisterRatingInput, RegisterRatingOutput>('registerRating', input);
}
